import { MenuItem, FormControl } from "@mui/material";
import Chip from "@mui/material/Chip";
import Select from "@mui/material/Select";
import { width } from "@mui/system";

const DropdownSelect = ({ options, value, onChange, title }) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const coreScenarioOptions = [
    "Stated Policy",
    "Technology Driven",
    "System Change",
  ];

  return (
    <div className="dropdown-select">
      <div className="dropdown-select--title">{title}</div>
      <div className="dropdown-select--selector">
        <FormControl
          fullWidth
          size={"small"}
          sx={{
            borderRadius: 0,
            boxShadow: "0px 4px 8px 0px #b4b4b9",
            "& .MuiOutlinedInput-notchedOutline": {
              borderWidth: 0,
            },
          }}
        >
          <Select
            value={value}
            onChange={handleChange}
            autoWidth={false}
            MenuProps={{
              style: {
                maxHeight: "300px",
              },
            }}
          >
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}{" "}
                {coreScenarioOptions.includes(option) ? (
                  <Chip
                    sx={{
                      marginLeft: "10px",
                      fontSize: "10px",
                      fontWeight: "600",
                      // backgroundColor: "#5FCA7D",
                    }}
                    size="small"
                    label="core pathway"
                    color="info"
                  />
                ) : null}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default DropdownSelect;
